import React from 'react';
import { Link } from 'react-router-dom';
export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  imageUrl: string;
  category: string;
}
interface BlogCardProps {
  post: BlogPost;
}
export const BlogCard: React.FC<BlogCardProps> = ({
  post
}) => {
  // Default image if none is provided
  const defaultImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/dfdoXx5h84GymbJXQ9SBKB/air-conditioner-ventilation-installation-system-in-2025-03-27-06-10-19-utc.jpg';
  return <div className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1" data-id="element-76">
      <Link to={`/blog/${post.id}`} className="block" data-id="element-77">
        <div className="relative h-48 overflow-hidden" data-id="element-78">
          <img src={post.imageUrl || defaultImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" onError={e => {
          // If image fails to load, use default image
          e.currentTarget.src = defaultImage;
        }} data-id="element-79" />
          <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-3 py-1 m-2 rounded" data-id="element-80">
            {post.category}
          </div>
        </div>
        <div className="p-6" data-id="element-81">
          <h3 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2" data-id="element-82">
            {post.title}
          </h3>
          <p className="text-gray-600 text-sm mb-4" data-id="element-83">
            {new Date(post.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}{' '}
            • By {post.author}
          </p>
          <p className="text-gray-600 mb-4 line-clamp-3" data-id="element-84">{post.excerpt}</p>
          <div className="flex justify-end" data-id="element-85">
            <span className="text-blue-600 font-medium inline-flex items-center" data-id="element-86">
              Read more
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-87">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-88" />
              </svg>
            </span>
          </div>
        </div>
      </Link>
    </div>;
};